import { Link } from "react-router-dom";
import { type FooterRedirectLink } from "../schema";

const FooterLink = ({ title, pathname }: FooterRedirectLink) => {
  return (
    <>
      <Link
        className="hover:text-cultiv-yellow duration-300 ease-in-out text-sm sm:text-base md:text-xl xl:text-xl"
        to={pathname}
      >
        {title}
      </Link>
    </>
  );
};

export default FooterLink;
